// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.documents-section {
  margin-top: 1.5rem;
}

.documents-section h4 {
  margin-bottom: 1rem;
  color: #333;
  font-size: 1rem;
  font-weight: 600;
}

.upload-area {
  margin-bottom: 2rem;
}

.upload-box {
  border: 2px dashed #ccc;
  border-radius: 8px;
  padding: 3rem 2rem;
  text-align: center;
  background-color: #fafafa;
  margin-bottom: 0.5rem;
}

.upload-box p {
  color: #666;
  margin-bottom: 1rem;
  font-size: 0.9rem;
}

.file-input {
  display: none;
}

.upload-btn {
  background-color: #1976d2;
  color: white;
  padding: 0.75rem 1.5rem;
  border-radius: 6px;
  cursor: pointer;
  font-weight: 500;
  transition: background-color 0.2s;
}

.upload-btn:hover {
  background-color: #1565c0;
}

.file-formats {
  font-size: 0.8rem;
  color: #888;
  margin: 0;
}

.web-search-section {
  margin-top: 1.5rem;
}

.section-subtitle {
  color: #333;
  font-weight: 600;
  margin-bottom: 1.5rem;
  font-size: 0.9rem;
}

.form-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1.5rem;
  margin-bottom: 2rem;
}

.form-group {
  display: flex;
  flex-direction: column;
}

.form-group label {
  margin-bottom: 0.5rem;
  font-weight: 500;
  color: #333;
  font-size: 0.9rem;
}

.form-group input,
.form-group select,
.form-group textarea {
  padding: 0.75rem;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 0.9rem;
  background-color: white;
}

.form-group input:focus,
.form-group select:focus,
.form-group textarea:focus {
  outline: none;
  border-color: #1976d2;
}

.form-group input::placeholder {
  color: #aaa;
  font-style: italic;
}

.priority-urls {
  margin-top: 2rem;
  padding: 1.5rem;
  background-color: #f8f9fa;
  border-radius: 8px;
}

.priority-urls h4 {
  margin-bottom: 0.5rem;
  color: #333;
  font-size: 0.9rem;
  font-weight: 600;
}

.priority-urls p {
  margin-bottom: 1rem;
  color: #666;
  font-size: 0.8rem;
}

.url-input {
  display: flex;
  gap: 0.5rem;
  margin-bottom: 1rem;
}

.url-input input {
  flex: 1 1;
}

.url-input button {
  background-color: #1976d2;
  color: white;
  border: none;
  padding: 0.75rem 1rem;
  border-radius: 6px;
  cursor: pointer;
  font-weight: 500;
}

.url-input button:hover {
  background-color: #1565c0;
}

.urls-list {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.url-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem;
  background-color: white;
  border: 1px solid #ddd;
  border-radius: 4px;
}

.url-item span {
  color: #1976d2;
  font-size: 0.9rem;
}

.url-item button {
  background-color: #dc3545;
  color: white;
  border: none;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.url-item button:hover {
  background-color: #c82333;
}

.analysis-type-section {
  margin-top: 1.5rem;
}

.mode-selection {
  margin: 2rem 0;
}

.mode-selection h4 {
  margin-bottom: 1rem;
  color: #333;
  font-size: 1rem;
  font-weight: 600;
}

.mode-options {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
}

.mode-card {
  padding: 1.5rem;
  border: 2px solid #ddd;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s;
  background-color: white;
}

.mode-card:hover {
  border-color: #1976d2;
}

.mode-card.active {
  border-color: #1976d2;
  background-color: #e3f2fd;
}

.mode-card h5 {
  margin-bottom: 0.5rem;
  color: #333;
  font-size: 0.9rem;
  font-weight: 600;
}

.mode-card p {
  margin: 0;
  color: #666;
  font-size: 0.8rem;
}

.analysis-actions {
  margin-top: 2rem;
  text-align: center;
}

.analyze-btn {
  background-color: #1976d2;
  color: white;
  border: none;
  padding: 0.75rem 2rem;
  border-radius: 6px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;
}

.analyze-btn:hover:not(:disabled) {
  background-color: #1565c0;
}

.analyze-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.analyze-btn.primary {
  background-color: #1976d2;
}

.analysis-result-section {
  margin-top: 1.5rem;
}

.result-header {
  margin-bottom: 1.5rem;
}

.result-tag {
  background-color: #e3f2fd;
  color: #1976d2;
  padding: 0.25rem 0.75rem;
  border-radius: 4px;
  font-size: 0.8rem;
  font-weight: 500;
}

.result-header h4 {
  margin: 0.5rem 0 0 0;
  color: #333;
  font-size: 1.1rem;
}

.result-content {
  background-color: white;
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 1.5rem;
  margin-bottom: 1.5rem;
}

.result-text {
  line-height: 1.6;
  color: #444;
  white-space: pre-wrap;
}

.sources {
  margin-top: 1.5rem;
  padding-top: 1rem;
  border-top: 1px solid #eee;
}

.sources h5 {
  margin-bottom: 0.5rem;
  color: #555;
  font-size: 0.9rem;
}

.sources ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.sources li {
  padding: 0.25rem 0;
  color: #666;
  font-size: 0.8rem;
}

.sources li::before {
  content: "• ";
  color: #1976d2;
  margin-right: 0.5rem;
}

.result-actions {
  display: flex;
  justify-content: center;
  gap: 1rem;
  margin-top: 2rem;
}

.action-btn {
  padding: 0.75rem 1.5rem;
  border: none;
  border-radius: 6px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.action-btn.secondary {
  background-color: #f8f9fa;
  color: #666;
  border: 1px solid #ddd;
}

.action-btn.secondary:hover {
  background-color: #e9ecef;
}

.action-btn.primary {
  background-color: #1976d2;
  color: white;
}

.action-btn.primary:hover {
  background-color: #1565c0;
}

.no-results {
  text-align: center;
  padding: 3rem;
  color: #666;
}


.loading-indicator {
  margin-top: 15px;
  text-align: center;
}

.progress-bar {
  width: 100%;
  height: 8px;
  background-color: #f0f0f0;
  border-radius: 4px;
  overflow: hidden;
  margin-bottom: 10px;
}

.progress-fill {
  height: 100%;
  background-color: #4CAF50;
  transition: width 0.3s ease;
}

.loading-text {
  font-size: 14px;
  color: #666;
  font-weight: 500;
}`, "",{"version":3,"sources":["webpack://./src/components/Point2.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,WAAW;EACX,iBAAiB;AACnB;;AAEA;;;EAGE,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;;;EAGE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,uBAAuB;EACvB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,wBAAwB;EACxB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;AACb;;;AAGA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB","sourcesContent":[".documents-section {\n  margin-top: 1.5rem;\n}\n\n.documents-section h4 {\n  margin-bottom: 1rem;\n  color: #333;\n  font-size: 1rem;\n  font-weight: 600;\n}\n\n.upload-area {\n  margin-bottom: 2rem;\n}\n\n.upload-box {\n  border: 2px dashed #ccc;\n  border-radius: 8px;\n  padding: 3rem 2rem;\n  text-align: center;\n  background-color: #fafafa;\n  margin-bottom: 0.5rem;\n}\n\n.upload-box p {\n  color: #666;\n  margin-bottom: 1rem;\n  font-size: 0.9rem;\n}\n\n.file-input {\n  display: none;\n}\n\n.upload-btn {\n  background-color: #1976d2;\n  color: white;\n  padding: 0.75rem 1.5rem;\n  border-radius: 6px;\n  cursor: pointer;\n  font-weight: 500;\n  transition: background-color 0.2s;\n}\n\n.upload-btn:hover {\n  background-color: #1565c0;\n}\n\n.file-formats {\n  font-size: 0.8rem;\n  color: #888;\n  margin: 0;\n}\n\n.web-search-section {\n  margin-top: 1.5rem;\n}\n\n.section-subtitle {\n  color: #333;\n  font-weight: 600;\n  margin-bottom: 1.5rem;\n  font-size: 0.9rem;\n}\n\n.form-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 1.5rem;\n  margin-bottom: 2rem;\n}\n\n.form-group {\n  display: flex;\n  flex-direction: column;\n}\n\n.form-group label {\n  margin-bottom: 0.5rem;\n  font-weight: 500;\n  color: #333;\n  font-size: 0.9rem;\n}\n\n.form-group input,\n.form-group select,\n.form-group textarea {\n  padding: 0.75rem;\n  border: 1px solid #ddd;\n  border-radius: 6px;\n  font-size: 0.9rem;\n  background-color: white;\n}\n\n.form-group input:focus,\n.form-group select:focus,\n.form-group textarea:focus {\n  outline: none;\n  border-color: #1976d2;\n}\n\n.form-group input::placeholder {\n  color: #aaa;\n  font-style: italic;\n}\n\n.priority-urls {\n  margin-top: 2rem;\n  padding: 1.5rem;\n  background-color: #f8f9fa;\n  border-radius: 8px;\n}\n\n.priority-urls h4 {\n  margin-bottom: 0.5rem;\n  color: #333;\n  font-size: 0.9rem;\n  font-weight: 600;\n}\n\n.priority-urls p {\n  margin-bottom: 1rem;\n  color: #666;\n  font-size: 0.8rem;\n}\n\n.url-input {\n  display: flex;\n  gap: 0.5rem;\n  margin-bottom: 1rem;\n}\n\n.url-input input {\n  flex: 1;\n}\n\n.url-input button {\n  background-color: #1976d2;\n  color: white;\n  border: none;\n  padding: 0.75rem 1rem;\n  border-radius: 6px;\n  cursor: pointer;\n  font-weight: 500;\n}\n\n.url-input button:hover {\n  background-color: #1565c0;\n}\n\n.urls-list {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.url-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0.5rem;\n  background-color: white;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n}\n\n.url-item span {\n  color: #1976d2;\n  font-size: 0.9rem;\n}\n\n.url-item button {\n  background-color: #dc3545;\n  color: white;\n  border: none;\n  border-radius: 50%;\n  width: 24px;\n  height: 24px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.url-item button:hover {\n  background-color: #c82333;\n}\n\n.analysis-type-section {\n  margin-top: 1.5rem;\n}\n\n.mode-selection {\n  margin: 2rem 0;\n}\n\n.mode-selection h4 {\n  margin-bottom: 1rem;\n  color: #333;\n  font-size: 1rem;\n  font-weight: 600;\n}\n\n.mode-options {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 1rem;\n}\n\n.mode-card {\n  padding: 1.5rem;\n  border: 2px solid #ddd;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.2s;\n  background-color: white;\n}\n\n.mode-card:hover {\n  border-color: #1976d2;\n}\n\n.mode-card.active {\n  border-color: #1976d2;\n  background-color: #e3f2fd;\n}\n\n.mode-card h5 {\n  margin-bottom: 0.5rem;\n  color: #333;\n  font-size: 0.9rem;\n  font-weight: 600;\n}\n\n.mode-card p {\n  margin: 0;\n  color: #666;\n  font-size: 0.8rem;\n}\n\n.analysis-actions {\n  margin-top: 2rem;\n  text-align: center;\n}\n\n.analyze-btn {\n  background-color: #1976d2;\n  color: white;\n  border: none;\n  padding: 0.75rem 2rem;\n  border-radius: 6px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.analyze-btn:hover:not(:disabled) {\n  background-color: #1565c0;\n}\n\n.analyze-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.analyze-btn.primary {\n  background-color: #1976d2;\n}\n\n.analysis-result-section {\n  margin-top: 1.5rem;\n}\n\n.result-header {\n  margin-bottom: 1.5rem;\n}\n\n.result-tag {\n  background-color: #e3f2fd;\n  color: #1976d2;\n  padding: 0.25rem 0.75rem;\n  border-radius: 4px;\n  font-size: 0.8rem;\n  font-weight: 500;\n}\n\n.result-header h4 {\n  margin: 0.5rem 0 0 0;\n  color: #333;\n  font-size: 1.1rem;\n}\n\n.result-content {\n  background-color: white;\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  padding: 1.5rem;\n  margin-bottom: 1.5rem;\n}\n\n.result-text {\n  line-height: 1.6;\n  color: #444;\n  white-space: pre-wrap;\n}\n\n.sources {\n  margin-top: 1.5rem;\n  padding-top: 1rem;\n  border-top: 1px solid #eee;\n}\n\n.sources h5 {\n  margin-bottom: 0.5rem;\n  color: #555;\n  font-size: 0.9rem;\n}\n\n.sources ul {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.sources li {\n  padding: 0.25rem 0;\n  color: #666;\n  font-size: 0.8rem;\n}\n\n.sources li::before {\n  content: \"• \";\n  color: #1976d2;\n  margin-right: 0.5rem;\n}\n\n.result-actions {\n  display: flex;\n  justify-content: center;\n  gap: 1rem;\n  margin-top: 2rem;\n}\n\n.action-btn {\n  padding: 0.75rem 1.5rem;\n  border: none;\n  border-radius: 6px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.action-btn.secondary {\n  background-color: #f8f9fa;\n  color: #666;\n  border: 1px solid #ddd;\n}\n\n.action-btn.secondary:hover {\n  background-color: #e9ecef;\n}\n\n.action-btn.primary {\n  background-color: #1976d2;\n  color: white;\n}\n\n.action-btn.primary:hover {\n  background-color: #1565c0;\n}\n\n.no-results {\n  text-align: center;\n  padding: 3rem;\n  color: #666;\n}\n\n\n.loading-indicator {\n  margin-top: 15px;\n  text-align: center;\n}\n\n.progress-bar {\n  width: 100%;\n  height: 8px;\n  background-color: #f0f0f0;\n  border-radius: 4px;\n  overflow: hidden;\n  margin-bottom: 10px;\n}\n\n.progress-fill {\n  height: 100%;\n  background-color: #4CAF50;\n  transition: width 0.3s ease;\n}\n\n.loading-text {\n  font-size: 14px;\n  color: #666;\n  font-weight: 500;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
